var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.ranks),function(rank){return _c('RankUsersComponent',_vm._b({key:rank.api},'RankUsersComponent',rank,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }